module.exports = __webpack_public_path__ + "public/img/antabg.4d53f78c.png";